<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span>Adding Lead</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="leadForm" (submit)="addLead()">

                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 right-border">
                                <div class="form-group">
                                    <label class="form-label">Lead Name *</label>
                                    <input type="text" formControlName="name" class="form-control" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Lab Test Category *</label>
                                    <mat-select placeholder="Select Test Category" formControlName="lab_test_category"
                                        (selectionChange)="getLabTestCategorySubcategory($event.value)"
                                        (click)="setSearchValue('labtest')">
                                        <input class="mySearchInput" #testSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'labtest')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="testSearch">
                                        <mat-option>Select Test</mat-option>
                                        <mat-option [value]="test.id" *ngFor="let test of labTest">{{test.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.lab_test_category.errors" class="invalid-feedback">
                                        <div *ngIf="f.lab_test_category.errors.required">Lab test catergory is required</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Lead City *</label>
                                    <mat-select placeholder="Select City" formControlName="city_id"
                                        (click)="setSearchValue('city')">
                                        <input class="mySearchInput" #citySearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'city')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="citySearch">
                                        <mat-option>Select City</mat-option>
                                        <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.city_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.city_id.errors.required">city is required</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Lead Source *</label>
                                    <mat-select placeholder="Select Lead Source" formControlName="lead_source">
                                        <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.lead_source.errors" class="invalid-feedback">
                                        <div *ngIf="f.lead_source.errors.required">source is required</div>
                                    </div>
                                </div>


                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="form-group">
                                    <label class="form-label">Lead Mobile *</label>
                                    <input type="text" (blur) = 'checkMobile()' formControlName="mobile" class="form-control" />
                                    <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                        <div *ngIf="f.mobile.errors.required">Mobile is required</div>
                                        <div *ngIf="!f.mobile.valid && f.mobile.value">Invalid Mobile number format
                                        </div>
                                    </div>
                                </div>
                                    
                                <div class="form-group">
                                    <label class="form-label">Lab Test Subcategory *</label>
                                    <mat-select placeholder="Select Test Subcategory" formControlName="lab_test_subcategory"
                                     [disabled]="test_subcategory" (click)="setSearchValue('labtestsub')">
                                        <input class="mySearchInput" #categorySearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'labtestsub')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="categorySearch">
                                        <mat-option>Select Test</mat-option>
                                        <mat-option [value]="sub.id" *ngFor="let sub of labTestSubcategory">{{sub.name}}
                                        </mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.lab_test_subcategory.errors" class="invalid-feedback">
                                        <div *ngIf="f.lab_test_subcategory.errors.required">Subcategory is required
                                        </div>
                                    </div>
                                </div>

                               
                                <div class="form-group">
                                    <label class="form-label">Lead Owner *</label>
                                    <mat-select placeholder="Select Owner" formControlName="user_id"
                                        (click)="setSearchValue('user')">
                                        <input class="mySearchInput" #userSearch focused="'true'" type="text"
                                            (keyup)="searchOnSelect($event.target.value, 'user')"
                                            (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                            id="userSearch">
                                        <mat-option>Select User</mat-option>
                                        <mat-option [value]="bd.id" *ngFor="let bd of labBds">{{bd.name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.user_id.errors.required">Lead Owner is required</div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Create Lead</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Show mobile number allready exist modal-->
<div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Mobile Number Already Exists!</h4>
          <button type="button" class="close" (click)="hideModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <div class="col-sm-12" style="overflow: scroll">
						  <table class="table">
							<thead>
							  <tr>
								<th scope="col">#</th>
								<th scope="col">Lead ID</th>
								<th scope="col">Name</th>
								<th scope="col">Test Subcategory</th>
								<th scope="col">Mobile</th>
								<th scope="col">Source</th>
								<th scope="col">Date</th>
							  </tr>
							</thead>
							<tbody>
							  <tr *ngFor="let data of checkLeadData;let index = index;">
								<th scope="row">{{index+1}}</th>
								<td> {{data.id}}</td>
								<td>{{data.patient_name}}</td>
								<td>{{data.treatment_name}}</td>
								<td>{{data.mobile}}</td>
								<td>{{data.lead_source}}</td>
								<td>{{data.created_at*1000|date:'d MMM, yyyy'}}</td>
							  </tr>
							</tbody>
						  </table>
                      </div>
                  </div>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModal()">Close</button>
        </div>
      </div>
    </div>
</div>